import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { isFeatureEnabled } from './FeatureFlag';
import { Features } from './FeatureFlag.type';

const FEATURE_FLAGS_CHANGE_EVENT = 'featureFlagsChange';

const changeHandlerMap: Map<string, () => void> = new Map();

const globalFeatureFlagsChangeEventHandler = (): void => {
  changeHandlerMap.forEach((handler) => handler());
};

let isSingleListenerRegistered = false;

const registerFeatureFlagsChangeEventListener = (): void => {
  if (!isSingleListenerRegistered) {
    document.addEventListener(
      FEATURE_FLAGS_CHANGE_EVENT,
      globalFeatureFlagsChangeEventHandler,
    );

    isSingleListenerRegistered = true;
  }
};

export const useFeature = (featureName: Features): boolean => {
  const [isEnabled, setIsEnabled] = useState<boolean>(
    isFeatureEnabled(featureName),
  );
  const handleFeatureFlagsChange = (): void => {
    if (isEnabled !== isFeatureEnabled(featureName)) {
      setIsEnabled(!isEnabled);
    }
  };

  useEffect(() => {
    registerFeatureFlagsChangeEventListener();

    const featureFlagsChangeHandlerId = uuidv4();

    changeHandlerMap.set(featureFlagsChangeHandlerId, handleFeatureFlagsChange);

    return () => {
      changeHandlerMap.delete(featureFlagsChangeHandlerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isEnabled;
};
